import { sendCustomBugsnagReport } from './errors';
import { getFlag } from './unleashFlags/helpers';
import { FLAG_AMPLITUDE_INIT } from './unleashFlags/constants';
import { isBrowser } from 'utils/helpers';
import { DEPLOY_ENV_PRODUCTION } from '../../config/config';

const DEV_API_KEY = '870f92f552b21488e87dcbe8137e1841';
const PROD_API_KEY = '5264485becc8c2514878e127483d4d27';

export const AMPLITUDE_API_KEY = DEPLOY_ENV_PRODUCTION ? PROD_API_KEY : DEV_API_KEY;

let amplitudeInstance: any = {};

if (isBrowser && getFlag(FLAG_AMPLITUDE_INIT).enabled) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const amplitude = require('amplitude-js');
  const configureAmplitude = () => amplitude.getInstance();

  amplitudeInstance = configureAmplitude();
}

const proxiedAmplitudeInstance = new Proxy(amplitudeInstance, {
  get(target, prop, receiver) {
    let value = Reflect.get(target, prop, receiver);
    value = typeof value === 'function' ? value.bind(target) : value;

    return prop in target
      ? value
      : () => {
          return false;
        };
  },
});

export default {
  logEvent: async (type: string, payload?: any) => {
    try {
      await proxiedAmplitudeInstance.logEvent(type, payload);
    } catch (e) {
      sendCustomBugsnagReport('amplitude: logEvent', {
        e,
        type,
        payload,
      });
    }
  },
  setUserId: async (userId: string) => {
    try {
      await proxiedAmplitudeInstance.setUserId(userId);
    } catch (e) {
      sendCustomBugsnagReport('amplitude: setUserId', {
        e,
        userId,
      });
    }
  },
  setUserProperties: async (payload: any) => {
    try {
      await proxiedAmplitudeInstance.setUserProperties(payload);
    } catch (e) {
      sendCustomBugsnagReport('amplitude: setUserProperties', {
        e,
        payload,
      });
    }
  },
  init: async (key: string) => {
    try {
      await proxiedAmplitudeInstance.init(key);
    } catch (e) {
      sendCustomBugsnagReport('amplitude: init', {
        e,
        key,
      });
    }
  },
};
